<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="m9.75 3.75.563-1.125h2.437V1.5h-7.5v1.125h3.563L8.25 3.75c-2.348.067-4.5.548-4.5 2.625v6.375c0 1.125.832 2.047 1.912 2.213L4.5 16.125v.375H6L7.5 15h3l1.5 1.5h1.5v-.375l-1.162-1.162h-.008.008a2.244 2.244 0 0 0 1.912-2.213V6.375c0-2.077-2.152-2.558-4.5-2.625Zm-1.477 1.5h1.454c2.063.06 2.716.435 2.925.75H5.348c.21-.315.862-.69 2.925-.75Zm-.136 8.213H5.805a.73.73 0 0 1-.555-.713V12h2.918a1.103 1.103 0 0 0-.031 1.463Zm4.613-.713a.73.73 0 0 1-.555.713H9.863c.165-.195.262-.443.262-.713 0-.293-.113-.547-.293-.75h2.918v.75Zm0-2.25h-7.5v-3h7.5v3Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
